export default __webpack_public_path__ + "static/media/design-system.7fc5e5ff.webp";